<!--服务优势-->
<template>
    <div class="container">
        <div class="section">
            <div class="label">标准的产品服务体系</div>
            <div class="content first">
                <div
                    class="item "
                    v-for="(item,index) in serviceSystems"
                    :key="index"
                >
                    <img :src="item.img" style="height: 180px;width: 180px" alt/>
                    <div class="title">{{ item.title }}</div>
                    <div class="info">{{ item.text }}</div>
                </div>
            </div>
        </div>
        <div class="section bg" style="color:#FFFFFF">
            <div class="label">覆盖全用户的工单体系</div>
            <div class="content second">
                <div class="item"
                     v-for="(item,index) in orderSystems"
                     :key="index"
                >
                    <img class="image" :src="item.img" alt/>
                    <div>
                        <div class="title" style="color:#FFFFFF">{{ item.title }}</div>
                        <div class="info" style="color:#FFFFFF">{{ item.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF">
            <div class="label">“1对1”大客户专属支持体系</div>
            <div class="content third">
                <div class="panel-item"
                     v-for="(item,index) in supportSystems"
                     :key="index"
                     :style="{backgroundImage:`url(${item.bg})` }"
                >
                    <div class="icon">
                        <img class="logo" :src="item.logo" alt="">
                    </div>
                    <div class="title">
                        {{ item.title }}
                    </div>
                    <div class="text">
                        {{ item.text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'serviceAdvantage',
    data() {
        return {
            serviceSystems: [
                {
                    title: '灵活的功能组合模式',
                    text: '全产品链采用SASS构架，拥有所有系统灵活配置能力，提高了运行效率，增强了拓展性',
                    img: require('@/assets/image/choiceYC/serviceAdvantage/icon_7.png')
                },
                {
                    title: '完善的文档标准体系',
                    text: '平台均为标准化产品，对用户提供标准化适用文档及数据对接文档',
                    img: require('@/assets/image/choiceYC/serviceAdvantage/icon_8.png')
                },
                {
                    title: '高效的问题处置机制',
                    text: '平台提供常见问题，解决说明；并提供问题反馈工单，后台人员及时反馈与处置',
                    img: require('@/assets/image/choiceYC/serviceAdvantage/icon_9.png')
                }
            ],
            orderSystems: [
                {
                    title: '7*24小时工单',
                    text: '客户使用过程中如遇到问题可以随时通过工单进行咨询',
                    img: require('@/assets/image/choiceYC/serviceAdvantage/icon_10.png')
                },
                {
                    title: '2个工作日回复',
                    text: '回复时效行业领先，咨询类工单回复时效更可大幅缩短',
                    img: require('@/assets/image/choiceYC/serviceAdvantage/icon_11.png')
                },
                {
                    title: '专业技术支持人员',
                    text: '工单体系设有专职人员回复，专业且高效的解决用户疑问',
                    img: require('@/assets/image/choiceYC/serviceAdvantage/icon_12.png')
                }
            ],
            supportSystems: [
                {
                    logo: require('@/assets/image/choiceYC/serviceAdvantage/icon_13.png'),
                    bg: require('@/assets/image/choiceYC/serviceAdvantage/small_bg1.png'),
                    title: '专属EM群',
                    text: '专属EM群，各方协同解决问题'
                },
                {
                    logo: require('@/assets/image/choiceYC/serviceAdvantage/icon_14.png'),
                    bg: require('@/assets/image/choiceYC/serviceAdvantage/small_bg2.png'),
                    title: '技术支持',
                    text: '可依据协商，提供多种形式的技术支持手段'
                },
                {
                    logo: require('@/assets/image/choiceYC/serviceAdvantage/icon_15.png'),
                    bg: require('@/assets/image/choiceYC/serviceAdvantage/small_bg3.png'),
                    title: '商务定期拜访',
                    text: '商务定期拜访，了解产品使用情况，获取客户最新需求'
                },
                {
                    logo: require('@/assets/image/choiceYC/serviceAdvantage/icon_16.png'),
                    bg: require('@/assets/image/choiceYC/serviceAdvantage/small_bg4.png'),
                    title: '服务保障策略',
                    text: '可进行服务独立部署，流量高峰期服务更稳定性'
                }
            ]
        }
    },
    mounted() {

    },
    methods: {}
}
</script>


<style scoped lang="scss">
.container {
    height: 100%;
    width: 100%;

    .bg {
        background-image: url("~@/assets/image/choiceYC/serviceAdvantage/bg.png");
    }

    .section {
        padding: 100px 0;

        .label {
            font-size: 28px;
            text-align: center;
        }


        .content {
            display: flex;
            justify-content: center;
            margin: 50px auto 0 auto;
            width: 1080px;

            .item {
                width: calc(100% / 3 - 16px);
                text-align: center;
                color: #333333;
                margin-right: 64px;

                &:last-child {
                    margin-right: 0;
                }

                .title {
                    margin-top: 50px;
                    margin-bottom: 16px;
                    font-size: 22px;
                }

                .info {
                    font-size: 14px;
                    line-height: 22px;
                    padding: 0 32px;
                }
            }

            .panel-item {
                width: calc(50% - 16px);
                margin: 8px;
                height: 310px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                text-align: center;
                color: #FFFFFF;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .logo {
                    height: 70px;
                    width: 70px;
                }

                .title {
                    margin: 20px 0;
                    font-size: 28px;
                }

                .text {
                    font-size: 14px;
                }
            }
        }

        .second {
            .item {
                .image {
                    height: 126px;
                    width: 126px
                }
            }
        }

        .third {
            width: 1200px;
            flex-wrap: wrap;
        }
    }
}

@import "./style.scss";
</style>
